//ROAD
export const UPDATE_ROAD_DATA = `UPDATE_ROAD_DATA`
export const FETCH_ROAD_DATA = `FETCH_ROAD_DATA`
export const UPDATE_ROAD_COLUMNS = `UPDATE_ROAD_COLUMNS`
export const UPDATE_FILTERED_ROAD_DATA = `UPDATE_FILTERED_ROAD_DATA`
export const UPDATE_DUPLICATE_ROAD_DATA = `UPDATE_DUPLICATE_ROAD_DATA`
